import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const ReportsResultView = angular
  .module('acme.view.application.reports.result', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.directive.dataGrid',
    'acme.common.directive.datePicker',
    'acme.common.directive.fieldFocus',
    'acme.common.service.reportingApi',
    'acme.view.application.reports.result.controllers',
  ])
  .config(function ($stateProvider) {
    const reportsResult = {
      name: 'application.reports.result',
      url: '/results/:definitionId/result/:resultId',
      params: {
        reportStatus: null,
        resultId: null,
        reportJson: null,
      },
      views: {
        'subview-main': {
          controller: 'ReportsResultController',
          controllerAs: '$ctrl',
          templateUrl: 'views/application/views/reports/result/result.tpl.html',
        },
      },
      data: {
        pageTitle: 'Result',
        permissions: [
          'REPORTS_CREATE',
          'REPORTS_UPDATE',
          'REPORTS_EXECUTE',
          'REPORTS_OWNER_EXECUTE',
          'REPORTS_DOWNLOAD',
        ],
      },
    };

    $stateProvider.state(reportsResult);
  }).name;
